// removed by extract-text-webpack-plugin
module.exports = {"root":"root--2a5a0"};